/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_LoadInputs */

const en_us2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heaviest load`)
};

const pt_br2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior carga`)
};

const es_419_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor carga`)
};

const pt_pt2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior carga`)
};

const fr_fr2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge la plus lourde`)
};

const de_de2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstes Gewicht`)
};

const it_it2_workout_live_record_load = /** @type {(inputs: Workout_Live_Record_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico più alto`)
};

/**
* | output |
* | --- |
* | "Heaviest load" |
*
* @param {Workout_Live_Record_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_load = /** @type {((inputs?: Workout_Live_Record_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_load(inputs)
	if (locale === "es-419") return es_419_workout_live_record_load(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_load(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_load(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_load(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_load(inputs)
	return en_us2_workout_live_record_load(inputs)
});
export { workout_live_record_load as "workout-live.record_load" }